import React from 'react';
const UiContext = React.createContext();
export const UiContextProvider = UiContext.Provider;
export const UiContextConsumer = UiContext.Consumer;
export default UiContext;